import '@angular/compiler';
import { PageMainComponent } from './page.main/page.main.component';
import { LayoutMainComponent } from './layout.main/layout.main.component';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

@NgModule({
    declarations: [
        AppComponent,
        PageMainComponent,
        LayoutMainComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
